import { FC } from 'react';

/**
 * Props interface for the FormSelectOptions component.
 * ensuring that certain properties like `value` and `label` are always provided.
 */
interface Props {
  options: { value: string; label: string; selected?: boolean }[];
}

/**
 * The FormSelectOptions component renders a list of options for a select dropdown.
 * It expects an array of objects with `value`, `label`, and an optional `selected` properties.
 */
const FormSelectOptions: FC<Props> = ({ options }) => {
  return (
    // Fragment to wrap the list of options
    <>
      {// Check if options are provided and map through them
      options?.map((option) => (
        // Render each option with its value and label
        <option // line break
          key={option.value}
          value={option.value}
          selected={option.selected}
          disabled={option.selected}
        >
          {option.label}
        </option>
      ))}
    </>
  );
};

export { FormSelectOptions };
